(function() {
  'use strict';

  // Inject hiding styles IMMEDIATELY
  (function injectHidingStyles() {
    const style = document.createElement('style');
    style.id = 'kaching-hide-styles';
    style.textContent = `
      kaching-bundle:not(.kb-5335-redesigned):not(.kb-5335-fallback-visible) {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      kaching-bundle.kb-5335-redesigned,
      kaching-bundle.kb-5335-fallback-visible {
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        transition: opacity 0.3s ease;
      }

      .kb-5335-loader {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 40px 20px;
        min-height: 200px;
      }

      .kb-5335-loader-spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #408CFF;
        border-radius: 50%;
        animation: kb-spin 1s linear infinite;
      }

      @keyframes kb-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      kaching-bundle.kb-5335-redesigned .kb-5335-loader,
      kaching-bundle.kb-5335-fallback-visible .kb-5335-loader {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  })();

  // Function to get badge text for hardness value
  function getHardnessBadge(valueName) {
    const fallbackTags = {
      soft_tag: 'GENTLE',
      medium_tag: 'JUST RIGHT',
      hard_tag: 'INTENSE'
    };
    
    const metaTags = (window.productMetafields && window.productMetafields.hardnessDescriptions) || fallbackTags;
    
    const softVariations = ['Soft', 'Mehka', 'Mekana', 'Mehke', 'Mekane', 'Miękki', 'Měkký', 'Mäkký', 'Miękkie', 'Mäkká', 'Miękka'];
    const mediumVariations = ['Medium', 'Srednja', 'Srednje', 'Średni', 'Střední', 'Stredný', 'Średnie', 'Stredná', 'Średnia'];
    const hardVariations = ['Hard', 'Trda', 'Trde', 'Tvrda', 'Tvrde', 'Twardy', 'Tvrdý', 'Twarde', 'Tvrdá', 'Twarda'];
    
    if (softVariations.includes(valueName)) {
      return metaTags.soft_tag || fallbackTags.soft_tag;
    } else if (mediumVariations.includes(valueName)) {
      return metaTags.medium_tag || fallbackTags.medium_tag;
    } else if (hardVariations.includes(valueName)) {
      return metaTags.hard_tag || fallbackTags.hard_tag;
    }
    
    return '';
  }

  function injectStyles() {
    if (document.getElementById('kaching-redesign-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'kaching-redesign-styles';
    style.textContent = `
      .kb-5335-redesigned {
        background: #F5F5F5 !important;
        border-radius: 16px !important;
        padding: 0!important;
      }

      .kaching-bundles .kaching-bundles__invalid-variant-error, .kb-error-message{
        background-color: #FFFFFF!important;
        border: 1px solid rgba(248, 89, 103, 1)!important;
        border-radius: 25px!important;
        padding: 5px 10px!important;
        margin: 0 auto!important;
        margin-top: 10px!important;
        color: rgba(248, 89, 103, 1)!important;
        font-weight: 500!important;
        font-size: 11px!important;
      }


      .kb-title-wrapper {
        display: flex;
        align-items: center;
        gap: 16px;
        justify-content: center;
      }
      
      .kb-title-line {
        width: 40px;
        height: 1px;
        background: #ccc;
      }
      
      .kb-title {
        font-size: 18px;
        font-weight: bold;
        color: #000;
        margin-bottom: 24px;
        text-align: center;
      }
      
      .kb-layout {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      
      .kb-left-col {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(65, 64, 66, 0.2);
      }
      
      .kb-buttons-wrapper {
        display: flex;
        flex-direction: row;
        gap: 8px;
        width: 100%;
      }
      
      .kb-qty-button {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 3px;
        padding: 5px;
        border-radius: 16px;
        border: 2px solid rgba(65, 64, 66, 0.1);
        cursor: pointer;
        transition: all 0.2s ease;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        flex: 1;
      }
      
      .kb-qty-button.selected {
        /*border-color: rgba(0, 235, 190, 1);*/
        border-color: #a000ff;
        background: rgba(255, 255, 255, 1);
        background: rgba(153, 51, 204, 0.1);
      }

      .kb-qty-button.selected .kb-qty-title{
        color: #a000ff;
      }
      
      .kb-qty-button:hover {
        border-color: rgba(0, 235, 190, 0.6);
        border-color: #a000ff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(153, 51, 204, 0.15);
      }
      
      .kb-qty-title {
        font-size: 16px;
        font-weight: 800;
        color: rgba(65, 64, 66, 1);
        text-transform: uppercase;
        letter-spacing: -0.5px;
        font-family: var(--font-rubik-family);
      }
      
      .kb-qty-label {
        font-size: 12px;
        font-weight: 700;
        padding: 8px 16px;
        border-radius: 999px;
        background: rgba(138, 43, 226, 1);
        color: #fff;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      .kb-qty-button.selected .kb-qty-label {
        background: rgba(0, 235, 190, 1);
        color: rgba(65, 64, 66, 1);
      }

      
      
      .kb-qty-subtitle {
        font-size: 10px;
        font-weight: 700;
        color: rgba(255, 255, 255, 1);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        background-color: #a000ff;
        border-radius: 24px;
        padding: 6px 8px;
        font-family: var(--font-rubik-family);
      }

      /*.kb-qty-button.selected .kb-qty-subtitle {
        background: rgba(0, 235, 190, 1);
        color: rgba(0, 82, 66, 1);
      }*/
      
      .kb-price-row {
        display: flex;
        gap: 8px;
        align-items: baseline;
      }
      
      .kb-price {
        font-size: 16px;
        font-weight: 700;
        color: #000;
      }
      
      .kb-price-compare {
        font-size: 12px;
        color: rgba(0,0,0,0.45);
      }
      
      .kb-badge {
        font-size: 10px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-right-col {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      
      .kb-variants-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding-bottom: 8px!important;
        border-bottom: 0!important;
      }
      
      .kb-variant-card {
          display: flex;
          flex-direction: column;
          gap: 0px;
          border-radius: 12px;
      }
      
      .kb-variant-card-content {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
      }
      
      .kb-variant-image {
        width: 68px;
        height: 68px;
        object-fit: cover;
        border-radius: 12px;
        flex-shrink: 0;
        background-color: #FFFFFF;
      }
      
      .kb-selectors-row {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: 1;
      }
      
      .kb-number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 36px;
        padding: 6px 10px;
        border-radius: 999px;
        background: rgba(0,0,0,0.06);
        font-size: 12px;
        font-weight: 600;
        color: rgba(0,0,0,0.65);
      }
      
      .kb-option-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
      }
      
      .kb-option-label {
        font-size: 12px;
        font-weight: 500;
        color: rgba(65, 64, 66, 0.6);
      }
      
      .kb-trigger-button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
          border-width: 2px;
          padding-top: 8px;
          padding-right: 4px;
          padding-bottom: 8px;
          padding-left: 16px;

        border-radius: 16px;
        border: 2px solid rgba(65, 64, 66, 0.1);
        background: #fff;
        cursor: pointer;
        transition: border-color 0.2s ease, background 0.2s ease;
      }
      
      .kb-trigger-button:hover {
        border-color: rgba(0,0,0,0.3);
      }
      
      .kb-trigger-left {
        display: flex;
        gap: 0px;
        text-align: left;
        flex-direction: column;
      }
      
      .kb-swatch-display {
        display: none;
        width: 72px;
        height: 14px;
        border-radius: 24px;
      }
      
      .kb-swatch-display.visible {
        display: inline-block;
      }
      
      .kb-value-display {
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-caret {
        font-size: 0px;
        color: rgba(0,0,0,0.45);
      }
      
      .kb-dropdown {
        display: none;
        position: absolute;
        top: calc(100% + 6px);
        left: -80px;
        right: 0;
        background: #fff;
        border: 2px solid rgba(65, 64, 66, 0.1);
        border-radius: 16px;
        padding: 6px;
        z-index: 10000;
        /* Without a cap, the panel can extend over the product form below; high z-index then eats ATC clicks. */
        max-height: min(360px, 55vh);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        box-shadow: 0px 4px 6px 0px rgba(65, 64, 66, 0.2); 
      }
      
      .kb-dropdown.open {
        display: block;
      }

      .kb-dropdown.kb-dropdown-hardness-option {
        left: 0 !important;
        padding: 8px !important;
      }
      
      .kb-option-row {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 0px;
        border-radius: 12px;
        border: none;
        background: transparent;
        cursor: pointer;
        text-align: left;
        transition: background 0.15s ease;
        margin-bottom: 5px;
      }

      .kb-dropdown-hardness-option .kb-option-row{
        padding: 8px !important;
      }

      .kb-dropdown-hardness-option .kb-option-row:last-of-type{
        margin-bottom: 0px !important;
      }
      
      .kb-option-row:hover {
        background: rgba(0,0,0,0.04);
      }
      
      .kb-option-row.selected {
        background: rgba(244, 244, 244, 1);
      }
      
      .kb-option-row-wrapper {
        display: flex;
        align-items: center;
        gap: 14px;
        flex: 1;
      }
      
      .kb-option-preview {
        width: 68px;
        height: 68px;
        object-fit: cover;
        border-radius: 12px;
        flex-shrink: 0;
        background-color: #f4f4f4 !important;
      }
      
      .kb-option-detail {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      
      .kb-row-swatch {
        display: inline-block;
        width: 64px;
        height: 12px;
        border-radius: 6px;
      }
      
      .kb-row-swatch-img {
        width: 32px;
        height: 32px;
        object-fit: cover;
        border-radius: 8px;
      }
      
      .kb-row-label {
        font-size: 13px;
        font-weight: 600;
        color: #000;
      }
      
      .kb-hardness-row {
        display: flex;
        flex-direction: column;
        gap: 2px;
        width: 100%;
      }
      
      .kb-hardness-value {
        font-size: 14px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-hardness-badge {
          display: inline-block;
          padding: 2px 0px;
          border-radius: 24px;
          background: rgba(65, 64, 66, 1);
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          align-content: center;
          text-align: center;
      }
      
      .kb-hardness-badge-trigger {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.3px;
      }
      
      .kb-quantity-label {
        font-size: 12px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        margin-right: 12px;
      }
      
      .kb-quantity-section-label {
        font-size: 12px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        padding-top: 8px;
        padding-bottom: 0px;
        border-top: 1px solid rgba(65, 64, 66, 0.2);
      }
      
      .kb-info-row {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        justify-content: space-between;
      }
      
      .kb-bristle-info-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        background: rgba(65, 64, 66, 0.1);
        border: none;
        border-radius: 24px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 600;
        color: rgba(65, 64, 66, 0.8);
        text-transform: uppercase;
        letter-spacing: 0.3px;
        transition: all 0.2s ease;
      }
      
      .kb-bristle-info-btn:hover {
        background: rgba(65, 64, 66, 0.15);
      }
      
      .kb-bristle-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: none;
        align-items: center;
        justify-content: center;
        z-index: 100000;
        padding: 20px;
      }
      
      .kb-bristle-modal-overlay.open {
        display: flex;
      }
      
      .kb-bristle-modal {
        background: white;
        border-radius: 24px;
        max-width: 303px;
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        padding: 16px;
        position: relative;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE/Edge */
      }
      
      .kb-bristle-modal::-webkit-scrollbar {
        display: none; /* Chrome/Safari/Opera */
      }
      
      .kb-bristle-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 2px solid rgba(65, 64, 66, 0.1);
      }
      
      .kb-bristle-modal-title {
        font-size: 20px;
        font-weight: 800;
        color: #a000ff;
        text-transform: uppercase;
        letter-spacing: -0.5px;
        line-height: 1.2;
        font-family: var(--font-rubik-family);
      }
      
      .kb-bristle-modal-close {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background 0.2s ease;
      }
      
      .kb-bristle-modal-close:hover {
        background: rgba(139, 86, 255, 0.1);
      }
      
      .kb-bristle-option-section {
        border-bottom: 1px solid rgba(65, 64, 66, 0.2);
        padding-bottom: 16px;
      }
      
      .kb-bristle-option-section:last-child {
        margin-bottom: 0;
        border-bottom: none;
        padding-bottom: 0;
      }

      .kb-bristle-option-section:not(:first-child) {
        margin-top: 16px;
      }
      
      .kb-bristle-option-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 8px;
      }
      
      .kb-bristle-option-image {
        width: 60px;
        height: 60px;
        object-fit: contain;
        border-radius: 8px;
        background: rgba(65, 64, 66, 0.05);
        flex-shrink: 0;
      }
      
      .kb-bristle-option-title-group {
        flex: 1;
      }
      
      .kb-bristle-option-name {
        font-size: 22px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        margin-bottom: 0;
        line-height: .5;
      }
      
      .kb-bristle-option-badge {
        display: inline-block;
        padding: 0px 10px;
        border-radius: 24px;
        background: rgba(65, 64, 66, 1);
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        min-width: 72px;
        text-align: center;
      }
      
      .kb-bristle-option-subtitle {
        font-size: 12px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        margin-top: -4px;

      }
      
      .kb-bristle-option-description {
        font-size: 12px;
        color: rgba(65, 64, 66, 0.6);
        line-height: 1.6;
      }

      .bundle-tabs__container {
        display: none !important;
      }

      /* Custom price section */
      .kb-price-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0px!important;
        margin-top: 0px;
        padding-top: 10px;
        border-top: 1px solid rgba(65, 64, 66, 0.2);
      }
      
      .kb-price-label {
        display: none;
      }
      
      .kb-price-values {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      
      .kb-price-compare {
        font-size: 18px;
        font-weight: 700;
        color: #a000ff;
        font-family: var(--font-rubik-family);
        position: relative;
      }
      
      .kb-price-compare::after {
        content: '';
        position: absolute;
        left: -2px;
        right: -2px;
        top: 50%;
        height: 2px;
        background: #a000ff;
        transform: translateY(-50%) rotate(-8deg);
        transform-origin: center;
      }
      
      .kb-price-current {
        font-size: 18px;
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
        font-family: var(--font-rubik-family);
      }
      
      .kb-price-discount {
        padding: 2px 8px;
        border-radius: 24px;
        background: #a000ff;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-family: var(--font-rubik-family);
      }
      
      .kb-price-per-head {
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: rgba(65, 64, 66, 0.8);
        font-family: var(--font-rubik-family);
        line-height: 0.5;
      }

      .kb-price-per-head .heads_quantity {
        font-weight: 700;
      }
      
      .kb-price-per-head .quantity {
        font-weight: 700;
        color: rgba(65, 64, 66, 1);
      }
      
      .kb-price-per-head .price-value {
        color: rgba(65, 64, 66, 1);
      }

      .kb-price-per-head .dot {
        color: #a000ff;
        font-size: 22px;
        position: relative;
        top: 3px;
        padding-left: 3px;
        padding-right: 3px;
      }

      /* Error message styling */
      .kaching-bundles__out-of-stock {
        display: none !important;
      }

      
      

      

     

      @media (max-width: 768px) {
          .kb-block-redesigned{
              padding: 0px!important;
          }

          .kb-trigger-button{
              gap: 0px!important;
              padding-left: 8px!important;
          }

          .kb-selectors-row, .kb-variant-card-content{
            gap: 6px!important;
          }

          .kb-variant-card{
            font-size: 12px;
          }
          
          .kaching-bundles__invalid-variant-error {
            font-size: 11px !important;
            padding: 6px 10px !important;
          }

          .kb-hardness-badge-trigger{
            padding: 4px 6px!important;
            font-size: 8px;
          }
      }
    `;
    document.head.appendChild(style);
  }

  function parseBundleData() {
    const bundleBlock = document.querySelector('kaching-bundles-block');
    if (!bundleBlock) return null;
    
    try {
      const config = JSON.parse(bundleBlock.getAttribute('config'));
      const dealBlock = JSON.parse(bundleBlock.getAttribute('deal-block'));
      const product = JSON.parse(bundleBlock.getAttribute('product'));
      const translations = bundleBlock.getAttribute('translations') ? JSON.parse(bundleBlock.getAttribute('translations')) : {};
      const hardnessDescriptions = bundleBlock.getAttribute('hardness-descriptions') ? JSON.parse(bundleBlock.getAttribute('hardness-descriptions')) : null;
      
      return { config, dealBlock, product, translations, hardnessDescriptions };
    } catch (e) {
      console.error('Failed to parse:', e);
      return null;
    }
  }

  let redesignCount = 0;
  const MAX_REDESIGNS = 10;

  function redesignBundles() {
    const kachingBundle = document.querySelector('kaching-bundle');
    const bundleBlock = document.querySelector('kaching-bundles-block');
    const block = document.querySelector('.kaching-bundles__block');
    if (!block || block.dataset.kachingRedesigned === 'true') return;

    // Limit redesign attempts
    if (redesignCount >= MAX_REDESIGNS) {
      console.warn('⚠️ Max redesign attempts reached (10)');
      block.dataset.kachingRedesigned = 'true';
      return;
    }
    
    redesignCount++;

    const bundleData = parseBundleData();
    if (!bundleData) return;

    injectStyles();

    block.classList.add('kb-5335-redesigned');
    if (kachingBundle) {
      kachingBundle.classList.add('kb-5335-redesigned');
    }

    const blockTitle = block.querySelector('.kaching-bundles__block-title');
    if (blockTitle) {
      const titleText = blockTitle.textContent.trim();
      blockTitle.innerHTML = `
        <div class="kb-title-wrapper">
          <div class="kb-title-line"></div>
          <span>${titleText}</span>
          <div class="kb-title-line"></div>
        </div>
      `;
      blockTitle.classList.add('kb-title');
    }

    const normalizeImageUrl = (url) => {
      if (!url) return '';
      return url.startsWith('//') ? `https:${url}` : url;
    };

    const triggerRerender = () => {
      block.dataset.kachingRedesigned = 'false';
      setTimeout(() => redesignBundles(), 80);
    };

    // Get locale for translations
    const locale = bundleData.config.liquidLocale || bundleData.config.locale || 'en';
    
    // Translation for "SAVE"
    const saveTranslations = {
      'sl': 'POPUST',
      'hr': 'UŠTEDI',
      'cs': 'UŠETŘI',
      'pl': 'ZAOSZCZĘDŹ',
      'sk': 'UŠETRI',
      'en': 'SAVE'
    };
    const saveText = saveTranslations[locale] || saveTranslations['en'];

    const closeAllDropdowns = () => {
      block.querySelectorAll('.kb-dropdown').forEach((dropdown) => {
        dropdown.classList.remove('open');
      });
    };

    if (!document.body.dataset.kachingOptionDropdownListener) {
      document.addEventListener('click', closeAllDropdowns);
      document.body.dataset.kachingOptionDropdownListener = 'true';
    }

    const barsWrapper = block.querySelector('.kaching-bundles__bars');
    const barElements = barsWrapper ? Array.from(barsWrapper.querySelectorAll('.kaching-bundles__bar')) : [];
    if (!barsWrapper || !barElements.length) {
      block.dataset.kachingRedesigned = 'true';
      return;
    }

    const dealBarContent = new Map();
    barElements.forEach((bar) => {
      const barId = bar.dataset.dealBarId;
      if (!barId) return;

      const titleEl = bar.querySelector('.kaching-bundles__bar-title');
      const subtitleEl = bar.querySelector('.kaching-bundles__bar-subtitle');
      const labelEl = bar.querySelector('.kaching-bundles__bar-label');
      const priceEl = bar.querySelector('.kaching-bundles__bar-price');
      const compareEl = bar.querySelector('.kaching-bundles__bar-full-price');
      const badgeEl = bar.querySelector('.kaching-bundles__bar-most-popular__content');

      dealBarContent.set(barId, {
        title: titleEl ? titleEl.textContent.trim() : '',
        subtitle: subtitleEl ? subtitleEl.textContent.trim() : '',
        label: labelEl ? labelEl.textContent.trim() : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        fullPrice: compareEl ? compareEl.textContent.trim() : '',
        badge: badgeEl ? badgeEl.textContent.trim() : ''
      });
    });

    barsWrapper.style.display = 'none';

    const selectedBar = barElements.find((bar) => bar.classList.contains('kaching-bundles__bar--selected')) || barElements[0];
    if (!selectedBar) {
      block.dataset.kachingRedesigned = 'true';
      return;
    }

    const variantNameNodes = selectedBar.querySelectorAll('.kaching-bundles__bar-variant-names span');
    const variantLabels = Array.from(variantNameNodes).map((node) => node.textContent.trim()).filter(Boolean);

    const selectedDealBar = bundleData.dealBlock.dealBars.find((bar) => bar.id === selectedBar.dataset.dealBarId) || bundleData.dealBlock.dealBars[0];
    const selectedQty = selectedDealBar?.quantity || 1;

    const productOptions = bundleData.product.options || [];
    const productOptionsMap = new Map(productOptions.map((option) => [option.name, option]));

    const optionValueImages = new Map();
    productOptions.forEach((option, optionIndex) => {
      const valueMap = new Map();
      (bundleData.product.variants || []).forEach((variant) => {
        const value = variant.options?.[optionIndex];
        if (!value || valueMap.has(value)) return;
        const variantImageUrl = normalizeImageUrl(variant.image || '') || normalizeImageUrl(bundleData.product.image || '');
        if (variantImageUrl) {
          valueMap.set(value, variantImageUrl);
        }
      });
      optionValueImages.set(option.name, valueMap);
    });

    let layoutContainer = block.querySelector('.kaching-two-column');
    if (!layoutContainer) {
      layoutContainer = document.createElement('div');
      layoutContainer.className = 'kaching-two-column kb-layout';
      block.appendChild(layoutContainer);
    } else {
      layoutContainer.classList.add('kb-layout');
    }
    layoutContainer.innerHTML = '';

    const leftCol = document.createElement('div');
    leftCol.className = 'kb-left-col';

    const buttonsWrapper = document.createElement('div');
    buttonsWrapper.className = 'kb-buttons-wrapper';

    const rightCol = document.createElement('div');
    rightCol.className = 'kb-right-col';

    const buildVariantsForBar = (barElement) => {
      rightCol.innerHTML = '';

      const origVariants = barElement.querySelector('.kaching-bundles__bar-variants');
      if (origVariants) {
        origVariants.style.cssText = 'position: absolute !important; left: -9999px !important; visibility: hidden !important;';
      }

      const originalWrappers = origVariants ? Array.from(origVariants.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper')) : [];
      const dealBar = bundleData.dealBlock.dealBars.find((bar) => bar.id === barElement.dataset.dealBarId);
      const totalRows = originalWrappers.length || dealBar?.quantity || 1;
      
      // Track auto-switched selects to notify Kaching after build
      const autoSwitchedSelects = [];

      const buildOptionDropdown = (option, optionElement, currentValue, valueImageMap, currentSelections, allProductOptions, wrapperIndex) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'kb-option-wrapper';

        const optionLabel = document.createElement('div');
        optionLabel.className = 'kb-option-label';
        optionLabel.textContent = option.name;
        wrapper.appendChild(optionLabel);

        const triggerButton = document.createElement('button');
        triggerButton.type = 'button';
        triggerButton.className = 'kb-trigger-button';

        const leftGroup = document.createElement('div');
        leftGroup.className = 'kb-trigger-left';

        const valueDisplay = document.createElement('span');
        valueDisplay.className = 'kb-value-display';
        leftGroup.appendChild(valueDisplay);
        
        const swatchDisplay = document.createElement('span');
        swatchDisplay.className = 'kb-swatch-display';
        leftGroup.appendChild(swatchDisplay);

        triggerButton.appendChild(leftGroup);

        const caret = document.createElement('span');
        caret.className = 'kb-caret';
        caret.innerHTML = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 13.5L15.5 18.5L10.5 13.5" stroke="#414042" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        triggerButton.appendChild(caret);

        const dropdown = document.createElement('div');
        dropdown.className = 'kb-dropdown';
        dropdown.dataset.option = option.name;
        dropdown.dataset.optionName = option.name;

        const imagesMap = valueImageMap || new Map();
        
        // Filter available option values based on current selections
        const availableOptionValues = option.optionValues.filter((optVal) => {
          // Get the index of this option in the product options array
          const currentOptionIndex = allProductOptions.findIndex(opt => opt.name === option.name);
          if (currentOptionIndex === -1) return true; // If option not found, include it
          
          // For the first option (position 0), show all values that have at least one available variant
          // For subsequent options, filter based on previous selections
          const isFirstOption = currentOptionIndex === 0;
          
          // Check if there's ANY available variant that matches:
          // 1. This option value for the current option
          // 2. All other currently selected option values (only if not first option)
          let isAvailable = false;
          
          for (const variant of bundleData.product.variants) {
            // Check if variant is available
            if (!variant) continue;
            
            // Check availability - use availableForSale property
            if (variant.availableForSale === false) continue;
            
            // If inventory is managed by Shopify with deny policy, check quantity
            if (variant.inventoryManagement === 'shopify' && variant.inventoryPolicy === 'deny') {
              if (variant.inventoryQuantity !== undefined && variant.inventoryQuantity <= 0) {
                continue;
              }
            }
            
            // Check if this variant matches the current option value
            if (!variant.options || variant.options[currentOptionIndex] !== optVal.name) {
              continue;
            }
            
            // For first option, if we found an available variant with this value, include it
            if (isFirstOption) {
              isAvailable = true;
              break; // Found at least one available variant with this value
            }
            
            // For subsequent options, check if this variant matches all OTHER currently selected options
            let matchesOtherSelections = true;
            allProductOptions.forEach((opt, idx) => {
              if (idx === currentOptionIndex) return; // Skip current option
              
              const selectedValueForOpt = currentSelections[opt.name];
              // Only check if a selection was made for this option
              if (selectedValueForOpt) {
                if (!variant.options || !variant.options[idx] || variant.options[idx] !== selectedValueForOpt) {
                  matchesOtherSelections = false;
                }
              }
            });
            
            if (matchesOtherSelections) {
              isAvailable = true;
              break; // Found at least one matching available variant
            }
          }
          
          return isAvailable;
        });
        
        // If no available options, skip this dropdown entirely
        if (availableOptionValues.length === 0) {
          return null;
        }
        
        // Ensure selected value is available, otherwise use first available
        const isSelectedValueAvailable = availableOptionValues.some(optVal => optVal.name === currentValue);
        let selectedValue = isSelectedValueAvailable ? currentValue : (availableOptionValues[0]?.name || '');
        
        // If we switched to a different value due to availability, update the original SELECT element too
        if (selectedValue !== currentValue && optionElement.tagName === 'SELECT') {
          const optionToSelect = optionElement.querySelector(`option[value="${selectedValue}"]`) || 
                                optionElement.querySelector(`option[data-value="${selectedValue}"]`);
          if (optionToSelect) {
            optionElement.value = selectedValue;
            optionElement.selectedIndex = optionToSelect.index;
            optionToSelect.selected = true;
            console.log('[DEBUG AUTO-SWITCH] Auto-switched', option.name, 'from', currentValue, 'to', selectedValue, 'for wrapper index', wrapperIndex);
            // Track this select to notify Kaching after build completes
            autoSwitchedSelects.push(optionElement);
          }
        }

        // Check if this is a color-related option
        const colorOptionNames = ['Colour', 'Color', 'Boja', 'Barva', 'Kolor', 'Farba', 'Barwa'];
        const isColorOption = colorOptionNames.includes(option.name);
        
        // Check if this is a hardness/ingredient option
        const hardnessOptionNames = [
          'Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness', 
          'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
          'Twardość włókien', 'Active ingredient', 'Active ingredient ', 
          'Aktivni sastojak', 'Aktivna sestavina', 'Aktywny składnik', 
          'Aktivní složka', 'Aktívna zložka', 'Składnik aktywny', 'Twardość szczoteczki'
        ];
        const isHardnessOption = hardnessOptionNames.includes(option.name);

        if (isHardnessOption) {
          dropdown.classList.add('kb-dropdown-hardness-option');
        }

        const updateTriggerDisplay = (valueName) => {
          const optVal = availableOptionValues.find((val) => val.name === valueName) || availableOptionValues[0];
          if (!optVal) return;

          // Handle color swatches
          if (optVal.swatch && optVal.swatch.color) {
            swatchDisplay.classList.add('visible');
            swatchDisplay.style.background = optVal.swatch.color;
            swatchDisplay.style.backgroundImage = 'none';
          } else if (optVal.swatch && optVal.swatch.image) {
            swatchDisplay.classList.add('visible');
            swatchDisplay.style.background = `url(${normalizeImageUrl(optVal.swatch.image)}) center/cover`;
          } else {
            swatchDisplay.classList.remove('visible');
          }

          valueDisplay.textContent = optVal.name;

          // Handle hardness badge in trigger
          const existingBadge = leftGroup.querySelector('.kb-hardness-badge-trigger');
          if (existingBadge) {
            existingBadge.remove();
          }

          if (isHardnessOption) {
            const bristleHardnessValue = getHardnessBadge(optVal.name);
            if (bristleHardnessValue) {
              const triggerBadge = document.createElement('span');
              triggerBadge.className = 'kb-hardness-badge-trigger';
              triggerBadge.textContent = bristleHardnessValue;
              leftGroup.appendChild(triggerBadge);
            }
          }
        };

        const setSelectedValue = (valueName) => {
          selectedValue = valueName;
          updateTriggerDisplay(valueName);
          dropdown.querySelectorAll('[data-option-value]').forEach((node) => {
            if (node.dataset.optionValue === valueName) {
              node.classList.add('selected');
            } else {
              node.classList.remove('selected');
            }
          });
        };

        triggerButton.addEventListener('click', (event) => {
          event.stopPropagation();
          const wasOpen = dropdown.classList.contains('open');
          
          // Close all other dropdowns
          block.querySelectorAll('.kb-dropdown').forEach((dd) => {
            if (dd !== dropdown) {
              dd.classList.remove('open');
            }
          });
          
          // Toggle this dropdown
          if (wasOpen) {
            dropdown.classList.remove('open');
          } else {
            dropdown.classList.add('open');
          }
        });

        availableOptionValues.forEach((optVal) => {
          const optionRow = document.createElement('button');
          optionRow.type = 'button';
          optionRow.className = 'kb-option-row';
          optionRow.dataset.optionValue = optVal.name;

          const rowWrapper = document.createElement('div');
          rowWrapper.className = 'kb-option-row-wrapper';

          // For hardness/ingredient options, show special badge layout
          if (isHardnessOption) {
            const hardnessContainer = document.createElement('div');
            hardnessContainer.className = 'kb-hardness-row';
            
            const valueName = document.createElement('div');
            valueName.className = 'kb-hardness-value';
            valueName.textContent = optVal.name;
            hardnessContainer.appendChild(valueName);

            
            const bristleHardnessValue = getHardnessBadge(optVal.name);
            if (bristleHardnessValue) {
              const badge = document.createElement('span');
              badge.className = 'kb-hardness-badge';
              badge.textContent = bristleHardnessValue;
              hardnessContainer.appendChild(badge);
            }
            
            rowWrapper.appendChild(hardnessContainer);
          }
          // For color options, show image preview and color swatch
          else if (isColorOption) {
            const variantPreview = imagesMap.get(optVal.name);
            if (variantPreview) {
              const previewImg = document.createElement('img');
              previewImg.className = 'kb-option-preview';
              previewImg.src = variantPreview;
              previewImg.alt = optVal.name;
              rowWrapper.appendChild(previewImg);
            }

            const detailColumn = document.createElement('div');
            detailColumn.className = 'kb-option-detail';

            if (optVal.swatch && optVal.swatch.color) {
              const rowSwatch = document.createElement('span');
              rowSwatch.className = 'kb-row-swatch';
              rowSwatch.style.background = optVal.swatch.color;
              detailColumn.appendChild(rowSwatch);
            }

            const rowLabel = document.createElement('span');
            rowLabel.className = 'kb-row-label';
            rowLabel.textContent = optVal.name;
            detailColumn.appendChild(rowLabel);
            
            rowWrapper.appendChild(detailColumn);
          }
          // Default rendering for other options
          else {
            const detailColumn = document.createElement('div');
            detailColumn.className = 'kb-option-detail';
            
            const rowLabel = document.createElement('span');
            rowLabel.className = 'kb-row-label';
            rowLabel.textContent = optVal.name;
            detailColumn.appendChild(rowLabel);
            
            rowWrapper.appendChild(detailColumn);
          }

          optionRow.appendChild(rowWrapper);

          optionRow.addEventListener('click', (event) => {
            event.stopPropagation();
            if (optVal.name === selectedValue) {
              dropdown.classList.remove('open');
              return;
            }

            setSelectedValue(optVal.name);
            dropdown.classList.remove('open');

            if (optionElement.tagName === 'SELECT') {
              console.log('[DEBUG] Updating wrapper', wrapperIndex, 'option', option.name, 'to', optVal.name);
              
              // Get the currently selected bar (it might have changed)
              const currentSelectedBar = block.querySelector('.kaching-bundles__bar--selected') || barElement;
              
              // Update ONLY the SELECT element for THIS specific wrapper
              const origVariants = currentSelectedBar.querySelector('.kaching-bundles__bar-variants');
              const allOriginalWrappers = origVariants ? Array.from(origVariants.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper')) : [];
              const targetWrapper = allOriginalWrappers[wrapperIndex];
              
              console.log('[DEBUG] Found targetWrapper:', !!targetWrapper, 'total wrappers:', allOriginalWrappers.length);
              
              if (targetWrapper) {
                const selectEl = targetWrapper.querySelector(`select.kaching-bundles-option[data-name="${option.name}"]`);
                console.log('[DEBUG] Found SELECT:', !!selectEl, 'current value:', selectEl?.value);
                if (selectEl) {
                  
                  // Try to find option by value first
                  let optionEl = selectEl.querySelector(`option[value="${optVal.name}"]`);
                  
                  // If not found, try to find by data-value attribute
                  if (!optionEl) {
                    optionEl = selectEl.querySelector(`option[data-value="${optVal.name}"]`);
                  }
                  
                  // If still not found, try to find by text content
                  if (!optionEl) {
                    const allOptions = Array.from(selectEl.options);
                    optionEl = allOptions.find(opt => opt.textContent.trim() === optVal.name);
                  }
                  
                  if (optionEl) {
                    const targetValue = optionEl.value;
                    const selectId = `kb-select-${wrapperIndex}-${Date.now()}`;
                    selectEl.setAttribute('data-kb-updating', selectId);
                    
                    // Set value multiple ways to ensure it sticks
                    selectEl.value = targetValue;
                    selectEl.selectedIndex = optionEl.index;
                    optionEl.selected = true;
                    
                    console.log('[DEBUG] SET SELECT value to:', targetValue, 'verify:', selectEl.value);
                    
                    // Create a function to re-apply the value if it gets reverted
                    const reapplyValue = () => {
                      // Get fresh reference to current selected bar and wrappers
                      const freshBar = block.querySelector('.kaching-bundles__bar--selected') || currentSelectedBar;
                      const freshOrigVariants = freshBar.querySelector('.kaching-bundles__bar-variants');
                      const freshWrappers = freshOrigVariants ? Array.from(freshOrigVariants.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper')) : [];
                      
                      const currentSelect = freshBar.querySelector(`select[data-kb-updating="${selectId}"]`);
                      if (!currentSelect) {
                        // SELECT was recreated, find it again
                        const wrapper = freshWrappers[wrapperIndex];
                        const newSelect = wrapper?.querySelector(`select.kaching-bundles-option[data-name="${option.name}"]`);
                        if (newSelect && newSelect.value !== targetValue) {
                          const newOptionEl = newSelect.querySelector(`option[value="${targetValue}"]`) || 
                                             newSelect.querySelector(`option[data-value="${targetValue}"]`);
                          if (newOptionEl) {
                            newSelect.value = targetValue;
                            newSelect.selectedIndex = newOptionEl.index;
                            newOptionEl.selected = true;
                            newSelect.setAttribute('data-kb-updating', selectId);
                            newSelect.dispatchEvent(new Event('change', { bubbles: true }));
                          }
                        }
                        return;
                      }
                      
                      if (currentSelect.value !== targetValue) {
                        currentSelect.value = targetValue;
                        const freshOptionEl = currentSelect.querySelector(`option[value="${targetValue}"]`) || 
                                            currentSelect.querySelector(`option[data-value="${targetValue}"]`);
                        if (freshOptionEl) {
                          currentSelect.selectedIndex = freshOptionEl.index;
                          freshOptionEl.selected = true;
                        }
                        currentSelect.dispatchEvent(new Event('change', { bubbles: true }));
                        currentSelect.dispatchEvent(new Event('input', { bubbles: true }));
                      }
                    };
                    
                    // Verify and re-apply at multiple intervals
                    setTimeout(reapplyValue, 50);
                    setTimeout(reapplyValue, 150);
                    setTimeout(reapplyValue, 300);
                    setTimeout(reapplyValue, 500);
                  } else {
                    // Fallback: try setting value directly
                    selectEl.value = optVal.name;
                  }
                  
                  // Force change event multiple times to ensure Kaching processes it
                  selectEl.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
                  selectEl.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                }
              }
              
              // Also update the current optionElement
              optionElement.value = optVal.name;
              optionElement.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Trigger change event on the bar's radio to ensure Kaching processes
              const barRadio = currentSelectedBar.querySelector('input[type="radio"]');
              if (barRadio) {
                barRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }
              
              setTimeout(() => {
                console.log('[DEBUG SELECT] Rebuilding variants for bar...');
                const barToRebuild = block.querySelector('.kaching-bundles__bar--selected') || barElement;
                buildVariantsForBar(barToRebuild);
                
                // Update prices and errors after Kaching updates them
                setTimeout(() => {
                  const priceSection = layoutContainer.querySelector('.kb-price-section');
                  if (priceSection && priceSection._updatePrices) {
                    priceSection._updatePrices();
                  }
                  
                  // Update error messages after Kaching has processed
                  if (layoutContainer._updateErrorMessages) {
                    layoutContainer._updateErrorMessages();
                  }
                }, 500);
              }, 150);
              return;
            }

            console.log('[DEBUG] Updating swatch for wrapper', wrapperIndex, 'option', option.name, 'to', optVal.name);
            
            // Get the currently selected bar (it might have changed)
            const currentSelectedBar = block.querySelector('.kaching-bundles__bar--selected') || barElement;
            
            // Update ONLY the swatch dropdown for THIS specific wrapper
            const origVariants = currentSelectedBar.querySelector('.kaching-bundles__bar-variants');
            const allOriginalWrappers = origVariants ? Array.from(origVariants.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper')) : [];
            const targetWrapper = allOriginalWrappers[wrapperIndex];
            
            console.log('[DEBUG] Found targetWrapper for swatch:', !!targetWrapper, 'total wrappers:', allOriginalWrappers.length);
            
            if (targetWrapper) {
              const wrapperOptionElement = targetWrapper.querySelector(`.kaching-bundles-option[data-name="${option.name}"]`);
              if (wrapperOptionElement) {
                const wrapperTrigger = wrapperOptionElement.querySelector('.kaching-bundles__bar-variant-select');
                if (wrapperTrigger) {
                  // Click trigger to open dropdown
                  wrapperTrigger.click();
                  
                  setTimeout(() => {
                    const wrapperOptionsContainer = wrapperOptionElement.querySelector('.kaching-bundles__swatch-dropdown__options');
                    if (wrapperOptionsContainer) {
                      const wrapperOptions = wrapperOptionsContainer.querySelectorAll('.kaching-bundles__swatch-dropdown__option');
                      console.log('[DEBUG] Looking for swatch option:', optVal.name, 'in', wrapperOptions.length, 'options');
                      wrapperOptions.forEach((origOpt) => {
                        const optionSpan = origOpt.querySelector('span');
                        if (optionSpan && optionSpan.textContent.trim() === optVal.name) {
                          console.log('[DEBUG] Clicking swatch option:', optVal.name);
                          origOpt.click();
                        }
                      });
                    }
                  }, 50);
                }
              }
            }
            
            // Wait for update to complete, then trigger bar radio change
            setTimeout(() => {
              // Get the currently selected bar again (it might have changed)
              const currentSelectedBarForRadio = block.querySelector('.kaching-bundles__bar--selected') || barElement;
              
              // Trigger change event on the bar's radio to ensure Kaching processes
              const barRadio = currentSelectedBarForRadio.querySelector('input[type="radio"]');
              if (barRadio) {
                barRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }
              
              setTimeout(() => {
                console.log('[DEBUG SWATCH] Rebuilding variants for bar...');
                const barToRebuild = block.querySelector('.kaching-bundles__bar--selected') || barElement;
                buildVariantsForBar(barToRebuild);
                
                // Update prices and errors after Kaching updates them
                setTimeout(() => {
                  const priceSection = layoutContainer.querySelector('.kb-price-section');
                  if (priceSection && priceSection._updatePrices) {
                    priceSection._updatePrices();
                  }
                  
                  // Update error messages after Kaching has processed
                  if (layoutContainer._updateErrorMessages) {
                    layoutContainer._updateErrorMessages();
                  }
                }, 500);
              }, 150);
            }, 100);
          });

          dropdown.appendChild(optionRow);
        });

        wrapper.appendChild(triggerButton);
        wrapper.appendChild(dropdown);

        setSelectedValue(selectedValue);

        return wrapper;
      };

      const variantsGrid = document.createElement('div');
      variantsGrid.className = 'kb-variants-grid';

      for (let i = 0; i < totalRows; i++) {
        const originalWrapper = originalWrappers[i];
        if (!originalWrapper) continue;

        const optionElements = {};
        const currentSelections = {};

        productOptions.forEach((option, optionIndex) => {
          const selector = originalWrapper.querySelector(`.kaching-bundles-option[data-name="${option.name}"]`);
          if (!selector) return;
          optionElements[option.name] = selector;

          if (selector.tagName === 'SELECT') {
            currentSelections[option.name] = selector.value;
          } else {
            const displaySpan = selector.querySelector('.kaching-bundles__bar-variant-select span:not(.kaching-chevron)');
            if (displaySpan) {
              currentSelections[option.name] = displaySpan.textContent.trim();
            }
          }
        });

        const matchedVariant = bundleData.product.variants.find((variant) => {
          return productOptions.every((option, optionIndex) => {
            const selectedValue = currentSelections[option.name];
            if (!selectedValue) return true;
            return variant.options[optionIndex] === selectedValue;
          });
        });

        const card = document.createElement('div');
        card.className = 'kb-variant-card';
        
        const cardContent = document.createElement('div');
        cardContent.className = 'kb-variant-card-content';

        const imageUrl = normalizeImageUrl((matchedVariant && matchedVariant.image) || bundleData.product.image);
        if (imageUrl) {
          const image = document.createElement('img');
          image.className = 'kb-variant-image';
          image.src = imageUrl;
          image.alt = matchedVariant?.title || bundleData.product.title || '';
          image.loading = 'lazy';
          cardContent.appendChild(image);
        }

        const selectorsRow = document.createElement('div');
        selectorsRow.className = 'kb-selectors-row';

        /*const numberNode = originalWrapper.querySelector('.kaching-bundles__bar-variant-number');
        const numberText = numberNode ? numberNode.textContent.trim().replace(/\s+/g, ' ') : `#${i + 1}`;
        if (numberText) {
          const numberBadge = document.createElement('span');
          numberBadge.className = 'kb-number-badge';
          numberBadge.textContent = numberText;
          selectorsRow.appendChild(numberBadge);
        }*/

        productOptions.forEach((option) => {
          const optionData = productOptionsMap.get(option.name);
          const optionElement = optionElements[option.name];
          if (!optionData || !optionElement) return;

          const currentValue = currentSelections[option.name];
          const valueImageMap = optionValueImages.get(option.name);
          const dropdown = buildOptionDropdown(optionData, optionElement, currentValue, valueImageMap, currentSelections, productOptions, i);
          if (dropdown) {
            selectorsRow.appendChild(dropdown);
          }
        });

        cardContent.appendChild(selectorsRow);
        card.appendChild(cardContent);
        
        // Don't add errors here - they will be added by updateErrorMessages after Kaching processes
        
        variantsGrid.appendChild(card);
      }
      
      // After building all cards, notify Kaching about auto-switched selects
      if (autoSwitchedSelects.length > 0) {
        console.log('[DEBUG AUTO-SWITCH] Notifying Kaching about', autoSwitchedSelects.length, 'auto-switched selects');
        // Use a small delay to ensure the DOM is fully updated
        setTimeout(() => {
          autoSwitchedSelects.forEach(selectEl => {
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }, 50);
      }

      // Check if any option is hardness-related and add info button
      const hardnessOptionNames = [
        'Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness', 
        'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
        'Twardość włókien', 'Twardość szczoteczki'
      ];
      const hasHardnessOption = productOptions.some(opt => hardnessOptionNames.includes(opt.name));
      
        if (hasHardnessOption) {
          // Translate "Choose Options:"
          const chooseOptionsTranslations = {
            'sl': 'Izberite možnosti:',
            'hr': 'Odaberite opcije:',
            'sk': 'Vyberte možnosti:',
            'cs': 'Vyberte možnosti:',
            'pl': 'Wybierz opcje:',
            'en': 'Choose Options:'
          };
          const quantityText = chooseOptionsTranslations[locale] || 'Choose Options:';
          
          const infoRow = document.createElement('div');
        infoRow.className = 'kb-info-row';
        
        const quantityLabel = document.createElement('span');
        quantityLabel.className = 'kb-quantity-label';
        quantityLabel.textContent = quantityText;
        
        const bristleGuideText = (window.productMetafields && window.productMetafields.hardnessDescriptions && window.productMetafields.hardnessDescriptions.bristle_guide_button) || 'Bristle Guide';
        
        const infoBtn = document.createElement('button');
        infoBtn.type = 'button';
        infoBtn.className = 'kb-bristle-info-btn';
        infoBtn.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1.3125C5.87512 1.3125 4.7755 1.64607 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31496 5.86274 1.20233 7.00631 1.42179 8.10958C1.64124 9.21284 2.18292 10.2263 2.97833 11.0217C3.77374 11.8171 4.78716 12.3588 5.89043 12.5782C6.99369 12.7977 8.13726 12.685 9.17651 12.2546C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.3539 9.2245 12.6875 8.12488 12.6875 7C12.6859 5.49207 12.0862 4.04636 11.0199 2.98009C9.95364 1.91382 8.50793 1.31409 7 1.3125ZM6.78125 3.9375C6.91105 3.9375 7.03793 3.97599 7.14584 4.0481C7.25376 4.12021 7.33788 4.2227 7.38755 4.34261C7.43722 4.46253 7.45021 4.59448 7.42489 4.72178C7.39957 4.84908 7.33707 4.96601 7.24529 5.05779C7.15351 5.14957 7.03658 5.21207 6.90928 5.23739C6.78198 5.26271 6.65003 5.24972 6.53012 5.20005C6.4102 5.15038 6.30771 5.06626 6.2356 4.95834C6.16349 4.85042 6.125 4.72354 6.125 4.59375C6.125 4.4197 6.19414 4.25278 6.31721 4.12971C6.44028 4.00664 6.6072 3.9375 6.78125 3.9375ZM7.4375 10.0625C7.20544 10.0625 6.98288 9.97031 6.81878 9.80622C6.65469 9.64212 6.5625 9.41956 6.5625 9.1875V7C6.44647 7 6.33519 6.95391 6.25314 6.87186C6.1711 6.78981 6.125 6.67853 6.125 6.5625C6.125 6.44647 6.1711 6.33519 6.25314 6.25314C6.33519 6.17109 6.44647 6.125 6.5625 6.125C6.79457 6.125 7.01713 6.21719 7.18122 6.38128C7.34531 6.54538 7.4375 6.76794 7.4375 7V9.1875C7.55353 9.1875 7.66481 9.23359 7.74686 9.31564C7.82891 9.39769 7.875 9.50897 7.875 9.625C7.875 9.74103 7.82891 9.85231 7.74686 9.93436C7.66481 10.0164 7.55353 10.0625 7.4375 10.0625Z" fill="#414042" fill-opacity="0.6"/>
          </svg>
          <span>${bristleGuideText}</span>
        `;
        
        infoBtn.addEventListener('click', () => {
          const modal = document.querySelector('.kb-bristle-modal-overlay');
          if (modal) {
            modal.classList.add('open');
          }
        });
        
        infoRow.appendChild(quantityLabel);
        infoRow.appendChild(infoBtn);
        rightCol.appendChild(infoRow);
      }
      
      rightCol.appendChild(variantsGrid);
      
      // Function to update error messages (will be called after Kaching processes)
      const updateErrorMessages = () => {
        // Find current rightCol (it gets recreated on each build)
        const currentRightCol = layoutContainer.querySelector('.kb-right-col');
        if (!currentRightCol) {
          return;
        }
        
        // Find current selected bar element
        const currentSelectedBar = block.querySelector('.kaching-bundles__bar--selected');
        if (!currentSelectedBar) {
          return;
        }
        
        // Get current originalWrappers from the current bar element
        const origVariants = currentSelectedBar.querySelector('.kaching-bundles__bar-variants');
        const currentOriginalWrappers = origVariants ? Array.from(origVariants.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper')) : [];
        
        // Remove ALL existing error messages from rightCol (including in cards and price section area)
        const existingErrors = currentRightCol.querySelectorAll('.kb-error-message, .kaching-bundles__invalid-variant-error');
        existingErrors.forEach((err) => err.remove());
        
        // Also remove errors from variant cards specifically
        const variantCards = currentRightCol.querySelectorAll('.kb-variant-card');
        variantCards.forEach((card) => {
          const cardErrors = card.querySelectorAll('.kb-error-message, .kaching-bundles__invalid-variant-error');
          cardErrors.forEach((err) => err.remove());
        });
        
        // Wait for Kaching to process, then check actual variant availability
        setTimeout(() => {
          
          // Get current selections from the ORIGINAL SELECT elements, not the custom UI
          variantCards.forEach((card, index) => {
            const originalWrapper = currentOriginalWrappers[index];
            if (!originalWrapper) return;
            
            // Read selections from the original Kaching SELECT elements
            const currentSelections = {};
            productOptions.forEach((option) => {
              const selectEl = originalWrapper.querySelector(`select.kaching-bundles-option[data-name="${option.name}"]`);
              if (selectEl) {
                currentSelections[option.name] = selectEl.value;
              } else {
                // Fallback: try swatch dropdown
                const swatchElement = originalWrapper.querySelector(`.kaching-bundles-option[data-name="${option.name}"]`);
                if (swatchElement) {
                  const displaySpan = swatchElement.querySelector('.kaching-bundles__bar-variant-select span:not(.kaching-chevron)');
                  if (displaySpan) {
                    currentSelections[option.name] = displaySpan.textContent.trim();
                  }
                }
              }
            });
            
            // Find matching variant
            const matchedVariant = bundleData.product.variants.find((variant) => {
              return productOptions.every((option, optionIndex) => {
                const selectedValue = currentSelections[option.name];
                if (!selectedValue) return true;
                return variant.options[optionIndex] === selectedValue;
              });
            });
            
            // Check if variant is available
            if (!matchedVariant) {
              const errorMessage = document.createElement('div');
              errorMessage.className = 'kb-error-message';
              errorMessage.textContent = 'Oprosti, to trenutno ni na voljo.';
              card.appendChild(errorMessage);
            } else if (!matchedVariant.availableForSale) {
              // Check inventory if inventory policy is deny
              let isAvailable = false;
              if (matchedVariant.inventoryManagement === 'shopify' && matchedVariant.inventoryPolicy === 'deny') {
                isAvailable = (matchedVariant.inventoryQuantity || 0) > 0;
              } else {
                isAvailable = matchedVariant.availableForSale;
              }
              
              if (!isAvailable) {
                const errorMessage = document.createElement('div');
                errorMessage.className = 'kb-error-message';
                errorMessage.textContent = 'Oprosti, to trenutno ni na voljo.';
                card.appendChild(errorMessage);
              }
            }
          });
          
          // Check for out-of-stock error from Kaching (only if visible)
          const outOfStockEl = block.querySelector('.kaching-bundles__out-of-stock');
          if (outOfStockEl) {
            const outOfStockText = outOfStockEl.textContent.trim();
            const outOfStockDisplay = window.getComputedStyle(outOfStockEl).display;
            const isOutOfStockVisible = outOfStockDisplay !== 'none' && outOfStockDisplay !== '';
            
            if (outOfStockText && isOutOfStockVisible) {
              const errorMessage = document.createElement('div');
              errorMessage.className = 'kb-error-message';
              errorMessage.textContent = outOfStockText;
              currentRightCol.appendChild(errorMessage);
            }
          }
        }, 500);
      };
      
      // Initial error check
      updateErrorMessages();
      
      // Store update function on layoutContainer (not rightCol, since rightCol gets cleared)
      layoutContainer._updateErrorMessages = updateErrorMessages;
      
      // Add price section
      const priceSection = document.createElement('div');
      priceSection.className = 'kb-price-section';
      
      const priceLabel = document.createElement('div');
      priceLabel.className = 'kb-price-label';
      priceLabel.textContent = 'Total price';
      
      const priceValues = document.createElement('div');
      priceValues.className = 'kb-price-values';
      
      const priceCurrent = document.createElement('div');
      priceCurrent.className = 'kb-price-current';
      
      const priceCompare = document.createElement('div');
      priceCompare.className = 'kb-price-compare';
      
      const priceDiscount = document.createElement('div');
      priceDiscount.className = 'kb-price-discount';
      
      const pricePerHead = document.createElement('div');
      pricePerHead.className = 'kb-price-per-head';
      pricePerHead.style.display = 'none';
      
      // Function to calculate and update prices from the selected bar's DOM
      const updatePrices = () => {
        // Find the currently selected bar
        const currentSelectedBar = block.querySelector('.kaching-bundles__bar--selected');
        if (!currentSelectedBar) return;
        
        // Get prices from the selected bar's DOM
        const barPriceEl = currentSelectedBar.querySelector('.kaching-bundles__bar-price');
        
        if (barPriceEl) {
          const currentPrice = barPriceEl.textContent.trim();
          priceCurrent.textContent = currentPrice;
          
          // Get selected quantity
          const selectedQtyBtn = layoutContainer.querySelector('.kb-qty-button.selected');
          const selectedBarId = selectedQtyBtn ? selectedQtyBtn.dataset.barId : currentSelectedBar.dataset.dealBarId;
          const selectedDealBar = bundleData.dealBlock.dealBars.find(bar => String(bar.id) === String(selectedBarId));
          const selectedQty = Number(selectedDealBar?.quantity) || 1;

          const parsePriceAmount = (text) => {
            const match = (text || '').match(/([\d,\.]+)/);
            if (!match) return NaN;
            return parseFloat(match[1].replace(',', '.'));
          };

          const formatPriceAmount = (amount, sampleText) => {
            const sampleMatch = (sampleText || '').match(/([\d,\.]+)/);
            const currencyMatch = (sampleText || '').match(/([^\d,\.]+)/g);
            const currency = currencyMatch ? currencyMatch[currencyMatch.length - 1] : '€';
            let formattedPrice;
            if (sampleMatch && sampleMatch[1].includes(',')) {
              formattedPrice = amount.toFixed(2).replace('.', ',');
            } else {
              formattedPrice = amount.toFixed(2);
            }
            return formattedPrice + currency;
          };

          const roundUpCompareAt = (amount) => Math.ceil(amount * 10) / 10;
          
          // Check if product needs per-head pricing
          const productId = document.querySelector('product-info')?.getAttribute('data-product-id') || '';
          const showPerHead = productId === '8805477613908' || productId === '8581547950246';

          //console.log('showPerHead', showPerHead);
          
          // Calculate per-head price
          if (showPerHead) {
            const priceMatch = currentPrice.match(/([\d,\.]+)/);
            const currencyMatch = currentPrice.match(/([^\d,\.]+)/g);
            const currency = currencyMatch ? currencyMatch[currencyMatch.length - 1] : '€';
            
            if (priceMatch) {
              const priceStr = priceMatch[1].replace(',', '.');
              const totalPrice = parseFloat(priceStr);
              
              if (!isNaN(totalPrice)) {
                // Each package contains 3 heads
                const totalHeads = selectedQty * 3;
                const perHeadPrice = totalPrice / totalHeads;
                let formattedPerHead;
                
                if (priceMatch[1].includes(',')) {
                  formattedPerHead = perHeadPrice.toFixed(2).replace('.', ',');
                } else {
                  formattedPerHead = perHeadPrice.toFixed(2);
                }
                
                // Get locale-specific translations
                const locale = document.documentElement.lang || 'en';
                const translations = {
                  'sl': { plural: 'GLAVE ZA ŠČETKO', singular: 'GLAVO' },
                  'hr': { plural: 'GLAVA ČETKICE', singular: 'GLAVI' },
                  'sk': { plural: 'HLAVICE', singular: 'HLAVICU' },
                  'cs': { plural: 'HLAVICE', singular: 'HLAVICI' },
                  'pl': { plural: 'WYMIENNE KOŃCÓWKI', singular: 'KOŃCÓWKĘ' }
                };
                
                const trans = translations[locale] || { plural: 'BRUSH HEADS', singular: 'HEAD' };
                
                pricePerHead.innerHTML = `<span class="heads_quantity">${totalHeads}×</span> ${trans.plural} <span class="dot">•</span> <span class="price-value"><strong>${formattedPerHead}${currency}</strong>/${trans.singular}</span>`;
                pricePerHead.style.display = 'block';
              } else {
                pricePerHead.style.display = 'none';
              }
            } else {
              pricePerHead.style.display = 'none';
            }
          } else {
            pricePerHead.style.display = 'none';
          }
          
          // Derive original price from sale price + discount % on the qty button
          const subtitleEl = selectedQtyBtn?.querySelector('.kb-qty-subtitle');
          const subtitleText = subtitleEl?.textContent.trim()
            || dealBarContent.get(String(selectedBarId))?.subtitle
            || selectedDealBar?.subtitle
            || '';
          const discountMatch = subtitleText.match(/(\d+)\s*%/);
          const discountPercent = discountMatch ? Number(discountMatch[1]) : 0;

          const currentAmount = parsePriceAmount(currentPrice);
          let fullPrice = '';

          if (!isNaN(currentAmount) && discountPercent > 0 && discountPercent < 100) {
            const originalAmount = roundUpCompareAt(currentAmount / (1 - discountPercent / 100));
            fullPrice = formatPriceAmount(originalAmount, currentPrice);
          } else {
            // Fallback: Kaching compare-at from selected bar or qty-1 unit × quantity
            const qtyOneDealBar = bundleData.dealBlock.dealBars.find(bar => Number(bar.quantity) === 1);
            let qtyOneBar = qtyOneDealBar ? block.querySelector(`[data-deal-bar-id="${qtyOneDealBar.id}"]`) : null;
            if (!qtyOneBar) {
              qtyOneBar = barElements.find(bar => bar.querySelector('.kaching-bundles__bar-full-price')) || barElements[0];
            }

            const selectedBarFullPriceEl = currentSelectedBar.querySelector('.kaching-bundles__bar-full-price');
            const qtyOneFullPriceEl = qtyOneBar?.querySelector('.kaching-bundles__bar-full-price');
            const singleItemComparePrice = qtyOneFullPriceEl?.textContent.trim()
              || dealBarContent.get(qtyOneBar?.dataset.dealBarId)?.fullPrice
              || '';
            const selectedBarComparePrice = selectedBarFullPriceEl?.textContent.trim()
              || dealBarContent.get(currentSelectedBar.dataset.dealBarId)?.fullPrice
              || '';

            const unitCompareAmount = parsePriceAmount(singleItemComparePrice);
            const selectedCompareAmount = parsePriceAmount(selectedBarComparePrice);

            if (!isNaN(selectedCompareAmount) && selectedCompareAmount > currentAmount) {
              fullPrice = formatPriceAmount(roundUpCompareAt(selectedCompareAmount), selectedBarComparePrice);
            } else if (!isNaN(unitCompareAmount)) {
              fullPrice = formatPriceAmount(roundUpCompareAt(unitCompareAmount * selectedQty), singleItemComparePrice);
            }
          }

          if (fullPrice && parsePriceAmount(fullPrice) > currentAmount) {
            priceCompare.textContent = fullPrice;
            priceCompare.style.display = 'block';

            if (subtitleText) {
              let discountText = subtitleText;

              if (window.has_free_shipping && window.has_free_shipping_text) {
                discountText += ` <span style="color: #00EBBE;">${window.has_free_shipping_text}</span>`;
              }

              priceDiscount.innerHTML = discountText;
              priceDiscount.style.display = 'block';
            } else {
              priceDiscount.style.display = 'none';
            }
          } else {
            priceCompare.style.display = 'none';
            priceDiscount.style.display = 'none';
          }
        }
      };
      
      // Initial price update with delay to let Kaching set the initial prices
      setTimeout(updatePrices, 100);
      
      // Store updatePrices on the price section so we can call it later
      priceSection._updatePrices = updatePrices;
      
      priceValues.appendChild(priceCompare);
      priceValues.appendChild(priceCurrent);
      priceValues.appendChild(priceDiscount);
      
      priceSection.appendChild(priceLabel);
      priceSection.appendChild(priceValues);
      priceSection.appendChild(pricePerHead);
      
      rightCol.appendChild(priceSection);
    };

    bundleData.dealBlock.dealBars.forEach((dealBar) => {
      const content = dealBarContent.get(dealBar.id) || {};
      const originalBar = barElements.find((bar) => bar.dataset.dealBarId === dealBar.id);
      if (!originalBar) return;

      const isSelected = selectedBar.dataset.dealBarId === dealBar.id;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kb-qty-button';
      button.dataset.barId = dealBar.id;
      if (isSelected) {
        button.classList.add('selected');
      }

      const titleText = content.title || dealBar.title || String(dealBar.quantity || '');
      if (titleText) {
        const title = document.createElement('div');
        title.className = 'kb-qty-title';
        title.textContent = titleText;
        button.appendChild(title);
      }

      const labelText = content.label || '';
      if (labelText) {
        const label = document.createElement('div');
        label.className = 'kb-qty-label';
        label.textContent = labelText;
        button.appendChild(label);
      }

      const subtitleText = content.subtitle || dealBar.subtitle || '';
      if (subtitleText) {
        const subtitle = document.createElement('div');
        subtitle.className = 'kb-qty-subtitle';
        subtitle.textContent = subtitleText;
        button.appendChild(subtitle);
      }

      const badgeText = content.badge || '';
      if (badgeText) {
        const badge = document.createElement('span');
        badge.className = 'kb-badge';
        badge.textContent = badgeText;
        button.appendChild(badge);
      }


      button.addEventListener('click', () => {
        buttonsWrapper.querySelectorAll('.kb-qty-button').forEach(btn => btn.classList.remove('selected'));
        button.classList.add('selected');
        
        const radio = originalBar.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // Small delay to allow Kaching to update the DOM with error states
        setTimeout(() => {
          buildVariantsForBar(originalBar);
          
          // Update prices and errors after Kaching updates them
          setTimeout(() => {
            const priceSection = layoutContainer.querySelector('.kb-price-section');
            if (priceSection && priceSection._updatePrices) {
              priceSection._updatePrices();
            }
            
            // Update error messages after Kaching has processed
            if (layoutContainer._updateErrorMessages) {
              layoutContainer._updateErrorMessages();
            }
          }, 500);
        }, 50);
      });

      buttonsWrapper.appendChild(button);
    });

    // Add "Quantity:" label above buttons
    const quantitySectionTranslations = {
      'sl': 'Količina:',
      'hr': 'Količina:',
      'sk': 'Množstvo:',
      'cs': 'Množství:',
      'pl': 'Ilość:',
      'en': 'Quantity:'
    };
    const quantitySectionText = quantitySectionTranslations[locale] || 'Quantity:';
    
    const quantitySectionLabel = document.createElement('div');
    quantitySectionLabel.className = 'kb-quantity-section-label';
    quantitySectionLabel.textContent = quantitySectionText;
    
    leftCol.appendChild(quantitySectionLabel);
    leftCol.appendChild(buttonsWrapper);
    layoutContainer.appendChild(leftCol);

    // Build initial variants for the selected bar
    buildVariantsForBar(selectedBar);

    layoutContainer.appendChild(rightCol);

    // Create bristle hardness modal if needed
    const hardnessOptionNames = [
      'Hardness', 'Trdota ščetin', 'Bristle hardness', 'Bristles hardness', 
      'Tvrdoća čekinja', 'Twardość włosia', 'Tvrdost štětin', 'Tvrdosť štetín',
      'Twardość włókien', 'Twardość szczoteczki'
    ];
    const hardnessOption = productOptions.find(opt => hardnessOptionNames.includes(opt.name));
    const hasHardnessOption = !!hardnessOption;
    
    if (hasHardnessOption && !document.querySelector('.kb-bristle-modal-overlay')) {
      const modalOverlay = document.createElement('div');
      modalOverlay.className = 'kb-bristle-modal-overlay';
      
      const modal = document.createElement('div');
      modal.className = 'kb-bristle-modal';
      
      // Get the actual option values from the product
      const optionValues = hardnessOption.optionValues || [];
      const softValue = optionValues.find(v => ['Soft', 'Mehka', 'Mekana', 'Mehke', 'Mekane', 'Miękki', 'Měkký', 'Mäkký', 'Miękkie', 'Mäkká', 'Miękka'].includes(v.name));
      const mediumValue = optionValues.find(v => ['Medium', 'Srednja', 'Srednje', 'Średni', 'Střední', 'Stredný', 'Średnie', 'Stredná', 'Średnia'].includes(v.name));
      const hardValue = optionValues.find(v => ['Hard', 'Trda', 'Trde', 'Tvrda', 'Tvrde', 'Twardy', 'Tvrdý', 'Twarde', 'Tvrdá', 'Twarda'].includes(v.name));
      
      // Get descriptions from window.productMetafields or fallback to English
      const fallbackDesc = {
        soft: 'Perfect for those with sensitive teeth and gums. Our softest option ensures a gentle, soothing clean without irritation',
        soft_tag: 'GENTLE',
        soft_name: 'Soft',
        medium: 'Our most popular and recommended option, optimized for balance, comfort, and plaque control',
        medium_tag: 'JUST RIGHT',
        medium_name: 'Medium',
        hard: 'Ideal for polishing and a thorough clean. Not as harsh as traditional hard brushes, but best suited for those without sensitive gums',
        hard_tag: 'INTENSE',
        hard_name: 'Hard',
        bristle_guide_title: 'Bristle<br/>Hardness Guide'
      };
      
      const hardnessDesc = (window.productMetafields && window.productMetafields.hardnessDescriptions) || fallbackDesc;
      const softDesc = hardnessDesc.soft || fallbackDesc.soft;
      const softTag = hardnessDesc.soft_tag || fallbackDesc.soft_tag;
      const softName = (softValue && softValue.name) || hardnessDesc.soft_name || fallbackDesc.soft_name;
      const mediumDesc = hardnessDesc.medium || fallbackDesc.medium;
      const mediumTag = hardnessDesc.medium_tag || fallbackDesc.medium_tag;
      const mediumName = (mediumValue && mediumValue.name) || hardnessDesc.medium_name || fallbackDesc.medium_name;
      const hardDesc = hardnessDesc.hard || fallbackDesc.hard;
      const hardTag = hardnessDesc.hard_tag || fallbackDesc.hard_tag;
      const hardName = (hardValue && hardValue.name) || hardnessDesc.hard_name || fallbackDesc.hard_name;
      const modalTitle = hardnessDesc.bristle_guide_title || fallbackDesc.bristle_guide_title;
      
      modal.innerHTML = `
        <div class="kb-bristle-modal-header">
          <div class="kb-bristle-modal-title">${modalTitle}</div>
          <button class="kb-bristle-modal-close" type="button">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 12L12 20" stroke="#A000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 12L20 20" stroke="#A000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#A000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          </button>
        </div>
        
        <div class="kb-bristle-option-section">
          <div class="kb-bristle-option-name">${softName}</div>
          <div class="kb-bristle-option-badge">${softTag}</div>
          <div class="kb-bristle-option-description">${softDesc}</div>
        </div>
        
        <div class="kb-bristle-option-section">
          <div class="kb-bristle-option-name">${mediumName}</div>
          <div class="kb-bristle-option-badge">${mediumTag}</div>
          <div class="kb-bristle-option-description">${mediumDesc}</div>
        </div>
        
        <div class="kb-bristle-option-section">
          <div class="kb-bristle-option-name">${hardName}</div>
          <div class="kb-bristle-option-badge">${hardTag}</div>
          <div class="kb-bristle-option-description">${hardDesc}</div>
        </div>
      `;
      
      modalOverlay.appendChild(modal);
      document.body.appendChild(modalOverlay);
      
      // Close modal handlers
      const closeBtn = modal.querySelector('.kb-bristle-modal-close');
      closeBtn.addEventListener('click', () => {
        modalOverlay.classList.remove('open');
      });
      
      modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
          modalOverlay.classList.remove('open');
        }
      });
    }

    block.dataset.kachingRedesigned = 'true';
  }

  function init() {
    const checkInterval = setInterval(() => {
      const kachingBundle = document.querySelector('kaching-bundle');
      const block = document.querySelector('.kaching-bundles__block--loaded, .kaching-bundles__block');
      if (block && kachingBundle) {
        clearInterval(checkInterval);
        
        // Inject loader
        const loader = document.createElement('div');
        loader.className = 'kb-5335-loader';
        loader.innerHTML = '<div class="kb-5335-loader-spinner"></div>';
        kachingBundle.insertBefore(loader, kachingBundle.firstChild);
        
        // Fallback: show block after 7 seconds if redesign hasn't completed
        setTimeout(() => {
          if (!kachingBundle.classList.contains('kb-5335-redesigned')) {
            console.warn('⚠️ Redesign timeout - showing original bundle block');
            kachingBundle.classList.add('kb-5335-fallback-visible');
          }
        }, 7000);
        
        setTimeout(() => {
          redesignBundles();
        }, 800);
        
        // Watch for changes
        const observer = new MutationObserver(() => {
          const needsRedesign = block.dataset.kachingRedesigned !== 'true';
          if (needsRedesign) {
            redesignBundles();
          }
        });
        observer.observe(block, { childList: true, subtree: true, attributes: true });
      }
    }, 100);
    
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();